<template>
  <RevContainer>
    <div class="flex flex-col gap-32 pt-40 md:flex-row md:pt-0">
      <TheMainContent
        class="flex flex-col items-start justify-center space-y-20 md:w-1/2"
      >
        <h2 class="heading-1">{{ i18n(translations.title) }}</h2>

        <p class="body-1">{{ i18n(translations.subtitle) }}</p>

        <RevButton
          :to="
            resolveLocalizedRoute({ name: ROUTE_NAMES.DASHBOARD.SERVICES_HUB })
          "
          variant="primary"
        >
          {{ i18n(translations.cta) }}
        </RevButton>

        <RevLink :to="linkToFAQ">
          {{ i18n(translations.questions) }}
        </RevLink>
      </TheMainContent>

      <div class="flex items-center justify-center py-48 md:w-1/2 md:py-72">
        <RevIllustration
          alt=""
          :height="403"
          src="/img/checkout/emptyBasket.svg"
          :width="381"
        />
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevButton } from '@ds/components/Button'
import { RevContainer } from '@ds/components/Container'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import { ROUTE_NAMES } from '@/scopes/dashboard/constants'
import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import { CMS } from '~/scopes/cms/routes-names'

import translations from './Subscribed.translations'

const { features } = useMarketplace()

const resolveLocalizedRoute = useRouteLocationWithLocale()
const i18n = useI18n()

const isRepairAndReplaceEnabled = computed(
  () => features.insurances.withRepairAndReplaceOffer.enabled,
)

const linkToFAQ = computed(() => {
  if (isRepairAndReplaceEnabled.value) {
    return resolveLocalizedRoute({
      name: CMS.SERVICE,
      params: { pageName: 'ext-services' },
    })
  }

  return resolveLocalizedRoute({
    name: CMS.EVENT,
    params: { pageName: 'backup' },
  })
})
</script>
